import type {
  HTMLProps,
  ReactElement,
} from 'react';

import { components } from 'react-select';
import type {
  GroupBase,
  MultiValueGenericProps,
} from 'react-select';

import { OptionTypeBase } from '../types';

export function MultiValueContainer<
OptionType extends OptionTypeBase,
IsMulti extends boolean,
Group extends GroupBase<OptionType>,
>({
  children,
  innerProps,
  ...rest
}: MultiValueGenericProps<OptionType, IsMulti, Group>): ReactElement {
  const {
    selectProps: {
      getOptionValue,
    },
  } = rest;

  const data = rest.data as OptionType;

  return (
    <components.MultiValueContainer
      {...rest}
      innerProps={{
        ...innerProps,
        'data-n3__select-multi-value': getOptionValue(data),
      } as HTMLProps<HTMLDivElement>}
    >
      {children}
    </components.MultiValueContainer>
  );
}
